// @refresh reload
import { mount, StartClient } from "@solidjs/start/client";
import { getFonts } from "./utils/etc";
import { initSentry } from "~/utils/third_party/sentry";
import { getStorage } from "./utils/storage";
import { clientIdConfig } from "./data/partner_config";
import { initializeApp } from "./utils/client_init_service";

initSentry();

// Polyfills
if (!Object.hasOwnProperty("hasOwn")) {
  Object.defineProperty(Object, "hasOwn", {
    value: function (obj: any, prop: any) {
      if (obj == null) return false; // null and undefined are special cases
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
  });
}

if (
  !Array.prototype.hasOwnProperty("findLastIndex") ||
  typeof Array.prototype.findLastIndex !== "function"
) {
  Object.defineProperty(Array.prototype, "findLastIndex", {
    value: function <T>(
      predicate: (arg0: T, arg1: number, arg2: T[]) => boolean
    ) {
      for (let i = this.length - 1; i >= 0; i--) {
        if (predicate(this[i], i, this)) {
          return i;
        }
      }
      return -1;
    },
    writable: true,
    configurable: true,
  });
}

if (typeof String.prototype.replaceAll !== "function") {
  String.prototype.replaceAll = function (
    pattern: string | RegExp,
    replacement: string | ((substring: string, ...args: any[]) => string)
  ) {
    if (typeof pattern === "string") {
      pattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const regex = new RegExp(pattern, "g");

    if (typeof replacement === "function") {
      return this.replace(regex, replacement);
    }

    return this.replace(regex, replacement);
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    index = Math.trunc(index) || 0;

    if (index < 0) {
      index += this.length;
    }

    if (index < 0 || index >= this.length) {
      return undefined;
    }

    return this[index];
  };
}

function applyRnrSpecificStyles(clientId: string) {
  const isDarkThemeFromStorage = getStorage("isDarkTheme");

  if (window.location.hostname.includes("raisoni")) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/raisoni.css";
    document.head.appendChild(cssLink);

    // add classes imported from css file
    document.body.classList.add("raisoni-font-family");
    document.body.classList.add("raisoni-font-weights");
    document.body.classList.add("raisoni-colors");
  }

  if (clientId == clientIdConfig.axisClientId) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/axis.css";
    document.head.appendChild(cssLink);
  }

  if (clientId && isDarkThemeFromStorage === "true") {
    document.body.classList.add("darkTheme");
  }
}

function applyGiftingSpecificStyles() {
  const pathname = window.location.pathname;

  if (
    pathname.includes("pluto") ||
    pathname.includes("smart-gc") ||
    pathname.includes("gift-box")
  ) {
    // manually make body bg black for dark theme products
    document.body.classList.add("darkBg");
  }
}

function loadCSSBasedOnURLParam() {
  // apply default css
  const cssFile = "/styles/main.css";
  const cssLink = document.createElement("link");
  cssLink.rel = "stylesheet";
  cssLink.href = cssFile;
  document.head.appendChild(cssLink);

  // apply default fonts
  const fonts = getFonts();
  fonts.map((font) => {
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = font;
    return document.head.appendChild(fontLink);
  });

  // rnr
  const clientIdFromStorage = getStorage("clientId");
  if (clientIdFromStorage) {
    applyRnrSpecificStyles(clientIdFromStorage);
  }

  let hostname = window.location.hostname;

  if (hostname.includes("tata-digital") || hostname.includes("tatadigital")) {
    document.body.classList.add("darkTheme");
  }

  // gifting
  applyGiftingSpecificStyles();
}

// Main initialization and mount
(async () => {
  try {
    // Initialize app context (replaces middleware)
    await initializeApp();

    // Load CSS and fonts after initialization
    loadCSSBasedOnURLParam();

    // Mount the app
    mount(() => <StartClient />, document.getElementById("app")!);
  } catch (error) {
    console.error("[Entry] Failed to initialize app:", error);
    // Mount anyway to show error boundary
    loadCSSBasedOnURLParam();
    mount(() => <StartClient />, document.getElementById("app")!);
  }
})();